"use client";
import React, { useState, KeyboardEvent, ChangeEvent } from "react";
import { InputField } from "@/shared";
import { ContextProps, useGlobalContext } from "@/contexts/AppContext";
import Image from "next/image";
import styles from "./TagsInput.module.scss";

interface EmailInputProps {
	emailTags: string[];
	setEmailTags: React.Dispatch<React.SetStateAction<string[]>>;
}

const TagsInput = ({ emailTags, setEmailTags }: EmailInputProps) => {
	const { theme }: ContextProps = useGlobalContext();
	const [inputValue, setInputValue] = useState<string>("");

	// const handleKeyPress = (event: KeyboardEvent<HTMLInputElement>) => {
	//     if (event.key === 'Enter' || event.key === ',') {
	//         event.preventDefault();
	//         const emails = inputValue.split(',').map(email => email.trim()).filter(email => email.length > 0 && !emailTags.includes(email));
	//         // if (emails.length > 0) {
	//         if (inputValue.trim() !== "") {
	//             setInputValue('');
	//         }
	//         setEmailTags([...emailTags, ...emails])
	//     }
	// };
	const handleKeyPress = (event: KeyboardEvent<HTMLInputElement>) => {
		if (event.key === "Enter" || event.key === ",") {
			event.preventDefault();
			const emails = inputValue
				.split(",")
				.map(email => email.trim())
				.filter(email => email.length > 0 && !emailTags.includes(email));
			if (emails.length > 0) {
				setEmailTags([...emailTags, ...emails]);
				setInputValue("");
			}
		}
	};

	const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
		setInputValue(event.target.value);
	};
	const removeEmailTag = (email: string) => {
		setEmailTags(emailTags.filter((tag: any) => tag !== email));
	};
	const removeEmail = (index: number) => {
		const updatedEmails = emailTags.filter((_, i) => i !== index);
		setEmailTags(updatedEmails);
	};

	return (
		<div className={styles.tags_input}>
			<div className={styles.tag_container}>
				{emailTags.map((tag: any, index: number) => (
					<div key={index} className={styles.tag}>
						<h3 className={styles.tag_title}>{tag}</h3>
						<div
							className={styles.tag_close_icon}
							onClick={() => removeEmailTag(tag)}
						>
							<Image alt="close" fill src={`/svgs/plus-${theme}.svg`} />
						</div>
					</div>
				))}
				<InputField
					type="email"
					inputClass={styles.email_text}
					onKeyUp={handleKeyPress}
					onChange={handleChange}
					value={inputValue}
					placeholder={
						emailTags.length === 0 ? "Enter email, separate with comma" : ""
					}
					className={styles.inputEdit}
				/>
			</div>
		</div>
	);
};

export default TagsInput;
